<template>
  <div>
    <navHeader />
    <div class="container-lg mt-5">
      <div class="row">
        <div class="col">
          <div class="p-3">
            <h2 class="main-title text-center">Preferred Shares</h2>
            <p class="text-muted text-right">As of {{ dateToday }}</p>
            <div class="table-responsive mt-3">
            
              <table class="table secondary-table table-bordered" v-if="!isDataLoaded">
                <thead class="text-nowrap text-center">
                  <tr>
                    <th class="text-center">Stock</th>
                    <th class="text-center">Company</th>
                    <th class="text-center">Dividend Per Period</th>
                    <th class="text-center">Offer Price</th>
                    <th class="text-center">Annualized Div Yield (Offer)</th>
                    <th class="text-center">Current Price</th>
                    <th class="text-center">Annualized Div Yield (Current)</th>
                    <th class="text-center">Prospectus*</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in reports.preferredShares" :key="index">
                    <td class="text-left">
                      <b>{{ item.stock }}</b>
                    </td>
                    <td class="text-left">{{ item.company }}</td>
                    <td class="text-right">{{ item.dividendPerPeriod }}</td>
                    <td class="text-right">{{ FormatPrices(item.offerPrice) }}</td>
                    <td class="text-right">
                      {{ FormatYield(item.annualizedDividendYeildOffer) }} %
                    </td>
                    <td class="text-right">{{ FormatPrices(item.currentPrice) }}</td>
                    <td class="text-right">
                      {{ FormatYield(item.annualizedDividendYeildCurrent) }}%
                    </td>
                    <td class="text-center">
                      <a target="_blank" :href="item.prospectus"
                        ><i class="bi bi-filetype-pdf"></i
                      ></a>
                    </td>
                  </tr>
                  
                </tbody>
                
              </table>
              
                <p class="text-muted text-left"><br>Note: In Dividend per period, default is quarterly, Red Cell  means semi-annual.</p>
                    <p class="text-muted text-left">Initial Prospectus or other supporting documents if the final prospectus is not available.</p>

              <div v-if="hasError || reports.preferredShares.length == 0">
                   <Noresult/>
              </div>
              <b-skeleton-table
                :rows="20"
                :columns="8"
                :table-props="{ bordered: true, striped: true }"
                v-if="isDataLoaded"
              ></b-skeleton-table>
            </div>
            <a href="javascript:void(0)" @click="ViewArchive()">
              View Preferred Shares archive
            </a>

          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import navHeader from "../../ResearchPages/NavHeader";
import Footer from "../Footer";
import { mapState } from "vuex";
import moment from "moment";
import Noresult from "../NoResult.vue";

export default {
  components: {
    navHeader,
   Noresult,
    Footer,
  },
  data() {
    return {
      isDataLoaded: false,
      hasError:false,
      dateToday:moment().format('LLL'),
    };
  },

  computed: {
    ...mapState({
      reports: (state) => state.philstocksResearch.preferredShares,
    }),
  },

  methods: {
     GoogleAnalytics() {
      this.$gtag.event("PreferredShares", { method: "Google" });
    },
    ViewArchive() {
      this.$router.push("PreferredShares/Archive");
    },

    FormatPrices(data) {
      var price = parseFloat(data);
      if (price == 0) {
        return price.toLocaleString("en-US", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
      } else if (price < 0.51) {
        return price.toLocaleString("en-US", {
          minimumFractionDigits: 4,
          maximumFractionDigits: 4,
        });
      } else if (price >= 1000) {
        return price.toLocaleString("en-US", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
      } else {
        return price.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      }
    },
    FormatYield(data) {
      var price = parseFloat(data);
      if (isNaN(price) || price == 0) {
        return 0;
      } else {
        return price.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      }
    },
    FormatDate(date) {
      var result = "";
      if (date == "0001-01-01T00:00:00") {
        result = "-------";
      } else {
        result = moment(date).format("LL");
      }
      return result;
    },

    async GetPreferredSharesContent(data) {
      var isResponseError = false;
      this.isDataLoaded = true;
      var _this = this;
      await this.$store
        .dispatch("philstocksResearch/GetPreferredShares", data)
        .catch(function (error) {
          console.log(error);
          _this.isDataLoaded = false;
          _this.hasError = true;
          isResponseError = false;
        });

      if (!isResponseError) {
        _this.isDataLoaded = false;
      }
    },
  },

  async mounted() {
    this.GetPreferredSharesContent(this.$route.query.date);
  },
};
</script>

<style></style>
